import React from 'react';

const Marquee = () => {
  const items = Array.from({ length: 8 });
  return (
    <div className="overflow-hidden border-y border-zinc-900 bg-black py-6">
      <div className="marquee-track flex gap-12 whitespace-nowrap" style={{ width: 'max-content' }}>
        {items.map((_, i) => (
          <span key={i} className="serif-italic gold-gradient-text text-5xl md:text-6xl">
            We Supply Smoke ·
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
